import { takeEvery, put, fork, call } from 'redux-saga/effects';

import { Client } from 'utils/client';
import { SIDE_MENU_ON_LOAD, privilegeOnSuccess, privilegeOnFailed, 
        REQUEST_MESSAGE_LOAD, requestMessageOnSuccess } from './actions';
import { appLogout } from 'redux-root/actions';

export function* initSession() {
  try {
    // const data = yield call(Client.getData, 'http://localhost:8090/api/v1/portal/users/privileges');
    const data = yield call(Client.getData, '/api/v1/portal/users/privileges');
    yield put(privilegeOnSuccess(data));
  } catch (error) {
    if (error.status === 401) {
      yield put(appLogout(true));
    }
    yield put(privilegeOnFailed(error))
  }
}
export function* getRequestMessageNum() {
  try {
    const data = yield call(Client.getData, '/api/v1/portal/requests/summary');
    yield put(requestMessageOnSuccess(data));
  } catch (error) {
   
  }
}

function* watchOnLoad() {
  yield takeEvery(SIDE_MENU_ON_LOAD, initSession);
  yield takeEvery(REQUEST_MESSAGE_LOAD, getRequestMessageNum);
}

export function* sideMenuSaga() {
  yield fork(watchOnLoad);
}
